import employeePositionService from "services/maintenance/employeePositionService";
import { MilitaryTechOutlined } from "@mui/icons-material";
import MAINTENANCE_STORE_SELECTORS from "features/maintenance/dataStore/selectors";

const employeePositionResource = {
    title: "Employee Positions",
    singular: "Employee Position",
    displayField: "description",
    service: employeePositionService,
    pageIcon: MilitaryTechOutlined,
    setter: MAINTENANCE_STORE_SELECTORS.EMPLOYEE_POSITION,

    columns: [
        {
            field: "positionCode",
            header: "Position Code",
            width: "15%"
        },
        {
            field: "description",
            header: "Description"
        },
        {
            field: "createdByName",
            header: "Created By",
            width: "10%"
        },
        {
            field: "updatedByName",
            header: "Updated By",
            width: "10%"
        }
    ],
    fields: [
        {
            name: "positionCode",
            label: "Position Code",
            type: "text",
            required: true,
            unique: true
        },
        {
            name: "description",
            label: "Description",
            type: "text",
            required: true
        }
    ],
    searchFields: ["positionCode", "description"]
};

export default employeePositionResource;
